import { render, staticRenderFns } from "./CallIvrMenus.vue?vue&type=template&id=659a01d4&"
import script from "./CallIvrMenus.vue?vue&type=script&lang=ts&"
export * from "./CallIvrMenus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports